import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';

import styles from './styles.scss';
import greyTile from './images/grey.svg';

export default class HomepageFeaturedRestaurantTile extends Component {
  onClick = (event) => {
    event.preventDefault();
    this.props.onClick({
      name: this.props.name,
      id: this.props.id,
    });
  };

  render() {
    const { id, name, image, description } = this.props;

    return (
      <li key={id} className={styles['list-item']}>
        <a data-name={name} className={styles.tile} onClick={this.onClick} href="#top">
          <div className={styles.image}>
            <BackgroundImage src={image || greyTile} />
          </div>
          <h3 className={styles.name}>{name}</h3>
          {description && <p className={styles.description}>{description}</p>}
        </a>
      </li>
    );
  }
}

HomepageFeaturedRestaurantTile.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

HomepageFeaturedRestaurantTile.defaultProps = {
  description: null,
  image: null,
};
